<template>
    <tr>
        <td class="align-middle" scope="col" :id="'c-m-hp-i-16-'+this.index">{{this.row.code}}</td>
        <td class="align-middle" scope="col" :id="'c-m-hp-i-17-'+this.index">
            <div class="d-flex align-items-start flex-column justify-content-between fs_08">
                <div>
                    <span>&#8594; </span>
                    <span :id="'c-m-hp-i-14-'+this.index"> {{this.row.dt_request}}</span>
                </div>
                <div>
                    <span>&#8592; </span>
                    <span :id="'c-m-hp-i-15-'+this.index"> {{this.row.dt_response}}</span>
                </div>
            </div>
            {{this.row.date}}
        </td>
        <td class="align-middle" scope="col fs_08">{{this.row.response}}</td>
        <td class="align-middle" scope="col">
            <i class='item-i' :class="{'check': this.row.success == '1',
                'x_red': this.row.success != '1'}"></i>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        row: [Object],
        index: [Number]
    }
}
</script>